import { createSelector } from 'reselect';
import moduleSelector from '../selector';
import { INIT_SUCCEEDED, APP_RELOAD_REQUESTED } from '../actions/types';
import { APP_LOADER_DISPLAYED, APP_LOADER_HIDDEN } from '../actions/refresh';
import { NETWORK_STATUS_CHANGED } from '../actions/networkStatus';
import { PREFETCH_STARTED, PREFETCH_FAILED, PREFETCH_SUCCEEDED } from '../actions/prefetch';
import { APP_TEARDOWN_STARTED } from '../actions/teardown';

export const NAME = 'status';

const initialState = {
    isInitialized: false,
    isNewVersionFetched: false,
    isOnline: false,
    isFetching: false,
    isVisible: true,
    isPrefetchingNewVersion: false,
    isTearingDown: false,
    needsReload: false,
};

export default function statusReducer(state = initialState, action: $TSFixMe) {
    switch (action.type) {
        case INIT_SUCCEEDED:
            return { ...state, isInitialized: true };

        case APP_LOADER_DISPLAYED:
            return { ...state, isFetching: true };

        case APP_LOADER_HIDDEN:
            return { ...state, isFetching: false };

        case NETWORK_STATUS_CHANGED:
            return { ...state, isOnline: action.payload };

        case PREFETCH_STARTED:
            return { ...state, isPrefetchingNewVersion: true };

        case PREFETCH_FAILED:
            return { ...state, isPrefetchingNewVersion: false };

        case PREFETCH_SUCCEEDED:
            return { ...state, isPrefetchingNewVersion: false, isNewVersionFetched: true };

        case APP_TEARDOWN_STARTED:
            return { ...state, isTearingDown: true };

        case APP_RELOAD_REQUESTED:
            return { ...state, needsReload: true };

        default:
            return state;
    }
}

export const getStatus = createSelector(moduleSelector, (state) => state[NAME]);

export const isNewAppVersionFetched = createSelector(getStatus, (state) => state.isNewVersionFetched);
export const isAppOnline = createSelector(getStatus, (state) => state.isOnline);
export const isAppFetching = createSelector(getStatus, (state) => state.isFetching);
export const isAppPrefetchingNewVersion = createSelector(getStatus, (state) => state.isPrefetchingNewVersion);
export const isAppTearingDown = createSelector(getStatus, (state) => state.isTearingDown);
export const appNeedsReload = createSelector(getStatus, (state) => state.needsReload);
